module.exports = __webpack_public_path__ + "6b4dda9dfa13de7ba6cc0adae18f52e0.svg";